// @flow

import { applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import { environment } from "buba-components";
import { composeWithDevTools } from "@redux-devtools/extension";

import { persistStore } from "redux-persist";
import user from "./user/reducer";

const configureStore = () => {
  const applyCommonMiddleware = applyMiddleware(thunk);

  const middleware = environment.isDevelopment()
    ? composeWithDevTools(applyCommonMiddleware)
    : applyCommonMiddleware;

  const store = createStore(combineReducers({ user }), middleware);

  const persistor = persistStore(store);

  return { store, persistor };
};

const { store: _store, persistor: _persistor } = configureStore();

export const store = _store;
export const persistor = _persistor;
